// Sprint 5 — KYC + TOS API schemas.
//
// Both surfaces are role-aware:
//   • KYC → bloqueante para VET (firma ECDSA) e BUYER (anti-fraude). Opcional
//           para FARMER ("Granxa verificada" badge no QR público).
//   • TOS → click-accept obrigatorio antes de crear o primeiro animal. O
//           backend persiste `tos_accepted_at` + versión; Documenso só se
//           usa cando se quere unha copia asinada do contrato.
import { z } from 'zod';
import { USER_ROLES } from './auth.js';
// ─── KYC ────────────────────────────────────────────────────────────────────
export const KycStatusSchema = z.enum([
    'NONE', // Nunca iniciou
    'PENDING', // Iniciou pero non subiu documentos
    'SUBMITTED', // Documentos enviados, DIDIT a procesar
    'VERIFIED', // Aprobado
    'REJECTED', // Denegado (pode reintentar)
]);
export const KycStatusResponseSchema = z.object({
    status: KycStatusSchema,
    /** Rol primario (mantense por compatibilidade); para UI multi-rol prefírese
     *  `applicable_roles`. Phase 12: USER_ROLES cubre TRANSPORTISTA. */
    role: z.enum(USER_ROLES),
    /**
     * Phase 25 iter-10 — todos os roles activos que comparten o KYC. A UI
     * móstraos no badge ("Aplícase a: FARMER, BUYER") para que o usuario
     * entenda que un único KYC cobre todos.
     */
    applicable_roles: z.array(z.enum(USER_ROLES)),
    /** True cando o role permite iniciar / reintentar verificación. */
    can_initiate: z.boolean(),
    /** True cando o role esixe KYC para acceder a features clave. */
    required: z.boolean(),
    verified_at: z.string().datetime().nullable(),
});
export const KycSessionResponseSchema = z.object({
    session_id: z.string(),
    verification_url: z.string().url(),
});
// ─── TOS (Termos do Servizo) ───────────────────────────────────────────────
/** Versión actual do TOS — incrementa cada vez que cambien os termos.
 *  Cando un usuario acepta v1 e despois sacamos v2, o status pasa a
 *  needs_reaccept=true e o gate de creación bloquea ata reaceptar. */
export const TOS_CURRENT_VERSION = 1;
export const TosStatusResponseSchema = z.object({
    accepted: z.boolean(),
    /** Versión que o usuario aceptou. Null se nunca aceptou. */
    accepted_version: z.number().int().nonnegative().nullable(),
    accepted_at: z.string().datetime().nullable(),
    /** Versión actual obrigatoria. */
    current_version: z.number().int().positive(),
    /** True se accepted_version < current_version (require reaccept). */
    needs_reaccept: z.boolean(),
    /** Doc ID Documenso (opcional, V1.5+ cando se queira contrato asinado). */
    document_id: z.string().nullable(),
});
export const TosAcceptRequestSchema = z.object({
    version: z.number().int().positive(),
});
//# sourceMappingURL=kyc.js.map